export function GetFixedCollectionIndex(collection:Array<any>, index:number): number
{
    const length: number = collection.length;
    return (length + index) % length;
}